// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__5xl+r","modal":"Modal_modal__SXXbt","closeIcon":"Modal_closeIcon__F2phl"};